import type { UiMessages } from "../types";

export const pl: UiMessages = {
  nav: {
    streams: "Kamerki",
    videos: "Filmy",
    shorts: "Shorts",
    forYou: "Dla Ciebie",
    vr: "VR",
    cartoon: "Kreskówki",
    hentai: "Hentai",
    sections: "Więcej",
    menu: "Menu",
    game: "Gra porno",
    stories: "Opowiadania erotyczne",
    escorts: "Escort",
    ai: "Dziewczyny AI",
    paysites: "Strony premium",
    home: "Strona główna",
    following: "Obserwowane",
    watching: "Oglądane",
    rankings: "Rankingi",
    invite: "Zaproś znajomych",
    coins: "Sweet Coin",
    achievements: "Osiągnięcia",
    hot: "Na topie",
    random: "Losowy film",
    saved: "Zapisane",
    reacted: "Polubione",
    boost: "Sweet Boost",
    premium: "Premium",
    stars: "Gwiazdy porno",
    productions: "Studia",
    categories: "Kategorie",
    telegram: "Kanał na Telegramie",
    allSections: "Wszystkie sekcje",
    mainNavigation: "Nawigacja główna",
    quickNavigation: "Szybka nawigacja",
    show: "Pokaż",
    coinsReady: "Sweet Coins do odebrania",
    logIn: "Zaloguj się",
    search: "Szukaj",
    closeSearch: "Zamknij wyszukiwanie",
    language: "Język",
    theme: "Motyw",
    themeDark: "Ciemny",
    themeLight: "Jasny",
  },
  age: {
    parents: "Rodzice: na naszej stronie o {link} wyjaśniamy, jak zablokować dostęp do tej witryny. Sweet ma oznaczenie RTA.",
    parentalControls: "kontroli rodzicielskiej",
    title: "To jest strona dla dorosłych",
    body: "Ta strona zawiera treści z ograniczeniem wiekowym, w tym nagość i dosłowne przedstawienia aktywności seksualnej. Wchodząc, potwierdzasz, że masz co najmniej 18 lat (albo tyle, ile wynosi wiek pełnoletności w kraju, z którego odwiedzasz stronę) i zgadzasz się na oglądanie treści o charakterze jednoznacznie seksualnym.",
    enter: "Mam ukończone 18 lat — Wchodzę",
    exit: "Nie mam 18 lat — Wychodzę",
  },
  consent: {
    title: "Pliki cookie",
    body: "Sweet jest darmowy dzięki reklamom. Nasi partnerzy reklamowi używają plików cookie, żeby je wyświetlać i liczyć ich wyświetlenia oraz kliknięcia. Niezbędne dane, takie jak potwierdzenie wieku, działają w każdym przypadku.",
    privacy: "Polityka prywatności",
    acceptAll: "Akceptuj wszystkie",
    onlyNecessary: "Tylko niezbędne",
    settings: "Ustawienia cookie",
  },
  ago: { now: "teraz", m: "{n} min", h: "{n} godz.", d: "{n} dn.", w: "{n} tyg.", mo: "{n} mies.", y: "{n} r." },
  cams: {
    allPlatforms: "Wszystkie platformy",
    watchOnSite: "Oglądaj na {site}",
    liveFor: "na żywo od {time}",
    tryAnother: "Wybierz inny tag lub region albo zajrzyj tu za chwilę.",
    nobodyLiveOn: "Nikt nie nadaje teraz na {name}",
    platformShowUpHint: "Transmisje z {name} pojawiają się tutaj, gdy tylko się zaczną. Zajrzyj za chwilę.",
    liveNowCount: "Na żywo: {n}",
    opensOn: "pokoje otwierają się na {site}",
    streamerSite: "stronie streamera",
    orWatch: "Albo obejrzyj {link}.",
    videoTag: "filmy #{tag}",
    liveStreams: "Transmisje na żywo",
    platformStreams: "Transmisje na żywo z {name}",
    liveCams: "Kamerki na żywo",
    platformCams: "Kamerki {name}",
    moreLiveCams: "Więcej kamerek na żywo",
    byTopic: "Kamerki na żywo według tematu",
    breadcrumb: "Ścieżka nawigacji",
    live: "Na żywo",
    viewers: "Widzowie:",
    isLive: "{name} nadaje na żywo",
    watchOn: "{title} — oglądaj na żywo na {site}",
    nobodyLive: "Nikt teraz nie nadaje",
    noMatch: "Brak transmisji pasujących do tych filtrów",
    showUpHint: "Transmisje pojawiają się tutaj, gdy tylko się zaczną. Zajrzyj za chwilę.",
    clearFilters: "Wyczyść filtry",
    clearAll: "Wyczyść wszystko",
    clear: "Wyczyść",
    seeAllPlatforms: "Zobacz wszystkie platformy",
    watchVideos: "Oglądaj filmy",
    onPlatform: " na {name}",
    newOnTelegram: "Nowe kamerki na Telegramie",
    loadMoreFailed: "Nie udało się załadować więcej — spróbuj ponownie",
    platforms: "Platformy",
    streamPlatforms: "Platformy z transmisjami",
    platformsAndFilters: "Platformy i filtry",
    categories: "Kategorie",
    all: "Wszystkie",
    region: "Region",
    allRegions: "Wszystkie regiony",
    more: "Więcej",
    newModels: "Nowe modelki",
    tags: "Tagi",
    removeTag: "Usuń tag",
    remove: "Usuń",
    loading: "Ładowanie",
    offline: "Offline",
    seeAll: "Zobacz wszystkie",
    genders: { female: "Kobiety", male: "Mężczyźni", couple: "Pary", trans: "Trans" },
    regions: { north_america: "Ameryka Północna", south_america: "Ameryka Południowa", europe: "Europa i Rosja", asia: "Azja", other: "Inne regiony" },
  },
  video: {
    fullScene: "Obejrzyj całą scenę na {site}",
    upNext: "Następne",
    nextPage: "Następna strona",
    moreVideos: "Więcej filmów",
    end: "To już wszystko.",
    loadMoreFailed: "Nie udało się załadować więcej — spróbuj ponownie",
    likes: "Polubienia",
    premiumVideo: "Film Premium",
    subscribeToWatch: "Wykup Premium, żeby obejrzeć cały film.",
    getPremium: "Kup Premium",
    logIn: "Zaloguj się",
    playsIn: "Odtwarzane w odtwarzaczu {name}",
    partnerBlocked: "Film jest odtwarzany z serwerów {name}, które są niedostępne z Twojej sieci: {name} może być blokowany przez Twojego dostawcę internetu lub w Twoim kraju.",
    unavailable: "Odtwarzacz {name} nie działa w Twoim kraju, więc tego filmu nie da się tu obejrzeć.",
    watchCams: "Zamiast tego oglądaj kamerki na żywo",
    chatLive: "Czatuj na żywo z {name} na {site}",
    play: "Odtwórz: {title}",
    sponsored: "Sponsorowane",
    onlyfansCreators: "Twórcy OnlyFans",
    liveNowFree: "Na żywo · za darmo",
    allVideos: "Wszystkie filmy",
    stoppedAt: "Zatrzymano na {at} z {of}",
    watchedToEnd: "Obejrzane do końca",
  },
  profile: { followers: "Obserwujący", views: "Wyświetlenia", videos: "Filmy", verified: "Zweryfikowany profil", follow: "Obserwuj", unfollow: "Przestań obserwować" },
  lists: {
    categories: "Kategorie",
    popular: "Popularne",
    aToZ: "A – Z",
    jumpToLetter: "Przejdź do litery",
    allCategories: "Wszystkie kategorie",
    noVideosYet: "Nie ma tu jeszcze filmów",
    pageN: "Strona {n}",
    newEveryDay: "Nowe filmy dodajemy codziennie.",
    videoCount: "filmy: {n}",
    pornstars: "Gwiazdy porno",
    pornstarsIntro: "Najchętniej obserwowani twórcy w tym tygodniu.",
    studios: "Studia porno",
    studiosIntro: "Wytwórnie i kanały według liczby obserwujących.",
    noVideosWithTag: "Brak filmów z tym tagiem",
    showAllVideos: "Pokaż wszystkie filmy",
  },
  hot: {
    title: "Na topie",
    intro: "Filmy najczęściej oglądane na Sweet w ostatnich godzinach.",
  },
  comments: {
    title: "Komentarze",
    placeholder: "Dodaj komentarz…",
    post: "Opublikuj",
    login: "Zaloguj się, żeby komentować",
    coinsHint: "+{n} Sweet Coins za każdy z pierwszych {max} komentarzy dziennie",
    earned: "+{n} Sweet Coins",
    empty: "Nie ma jeszcze komentarzy. Napisz pierwszy.",
    more: "Pokaż więcej",
    delete: "Usuń",
    short: "Napisz trochę więcej.",
    long: "Za długi komentarz: maksymalnie {n} znaków.",
    links: "Linki i dane kontaktowe są niedozwolone w komentarzach.",
    forbidden: "Tego komentarza nie można opublikować.",
    rate: "Komentujesz za szybko. Spróbuj ponownie później.",
    duplicate: "Ten komentarz został już opublikowany.",
    failed: "Nie udało się opublikować. Spróbuj ponownie.",
    like: "Lubię",
    dislike: "Nie lubię",
    rateLogin: "Zaloguj się, żeby oceniać filmy",
    liked: "{p}% polubień",
  },
  starVote: {
    title: "Gwiazda miesiąca",
    vote: "Głosuj",
    voteFor: "Zagłosuj na {name} jako gwiazdę miesiąca",
    voteAgain: "Zagłosuj ponownie · {n} monet",
    confirm: "Wydać {n} monet?",
    standing: "#{rank} w tym miesiącu · głosy: {n}",
    noVotes: "W tym miesiącu nie ma jeszcze głosów",
    thanks: "Dzięki za głos!",
    paidThanks: "Głos policzony · −{n} monet",
    coins: "Za mało monet: głos kosztuje {n}.",
    limit: "To wszystkie Twoje głosy na dziś.",
    rules: "Jeden darmowy głos dziennie, potem {n} monet za głos.",
    boardIntro: "Użytkownicy głosują na ulubione gwiazdy na ich stronach: jeden darmowy głos dziennie, kolejne po {n} monet.",
    boardEmpty: "W tym miesiącu nie ma jeszcze głosów. Zagłosuj na gwiazdę na jej stronie.",
    votes: "Głosy",
    lastWinner: "Gwiazda poprzedniego miesiąca",
    login: "Zaloguj się, żeby głosować",
  },
  achievements: {
    title: "Osiągnięcia",
    intro: "Odblokowuj osiągnięcia, oglądając, obserwując i biorąc udział w życiu Sweet. Każde daje Sweet Coins.",
    unlocked: "Odblokowane",
    coins: "+{n} monet",
    progress: "{x} z {n}",
    total: "Odblokowano {x} z {n}",
    login: "Zaloguj się, żeby zbierać osiągnięcia i monety za nie.",
    signup: "Załóż konto",
    toast: "Osiągnięcie odblokowane",
    names: {
      "videos-1": ["Pierwszy film", "Obejrzyj swój pierwszy film"],
      "videos-10": ["Rozgrzewka", "Obejrzyj 10 filmów"],
      "videos-100": ["Stały bywalec", "Obejrzyj 100 filmów"],
      "videos-1000": ["Koneser", "Obejrzyj 1000 filmów"],
      "hours-1": ["Pierwsza godzina", "Oglądaj przez godzinę"],
      "hours-10": ["Dziesięć godzin", "Oglądaj przez 10 godzin"],
      "hours-100": ["Maraton", "Oglądaj przez 100 godzin"],
      "streak-3": ["Trzy z rzędu", "Oglądaj 3 dni z rzędu"],
      "streak-7": ["Tydzień z rzędu", "Oglądaj codziennie przez tydzień"],
      "streak-30": ["Miesiąc z rzędu", "Oglądaj codziennie przez 30 dni"],
      "follows-5": ["Fan", "Obserwuj 5 gwiazd lub studiów"],
      "likes-25": ["Wielkie serce", "Polub 25 filmów"],
      "saves-10": ["Kolekcjoner", "Zapisz 10 filmów"],
      "days-7": ["Tydzień z monetami", "Odbierz monety przez 7 dni"],
      "days-30": ["Miesiąc z monetami", "Odbierz monety przez 30 dni"],
      "invites-1": ["Przyprowadź kumpla", "Zaproś znajomego, który założy konto"],
      "comments-1": ["Pierwsze słowa", "Napisz swój pierwszy komentarz"],
      "comments-25": ["Gaduła", "Napisz 25 komentarzy"],
      "votes-1": ["Wyborca", "Zagłosuj na gwiazdę miesiąca"],
    },
  },
  pwa: {
    appName: "Aplikacja Sweet",
    bannerLabel: "Zainstaluj aplikację",
    bannerPitch: "Pełny ekran, bez sklepu z aplikacjami",
    install: "Zainstaluj",
    notNow: "Nie teraz",
    installApp: "Zainstaluj aplikację",
    howToInstall: "Jak zainstalować",
    inApp: "Korzystasz z aplikacji.",
    cardPitch: "Pełny ekran i start jednym stuknięciem z ekranu początkowego. Bez sklepu z aplikacjami.",
    manual: "Otwórz menu przeglądarki i wybierz {install} lub {add}.",
    iosTitle: "Dodaj Sweet do ekranu początkowego",
    iosShare: "Stuknij {share} na pasku przeglądarki (w iOS 26: {more}, a potem {share})",
    iosAdd: "Wybierz {add}",
    iosConfirm: "Stuknij {confirm}: Sweet otworzy się na pełnym ekranie prosto z ekranu początkowego",
    share: "Udostępnij",
    more: "•••",
    add: "Do ekranu początkowego",
    confirm: "Dodaj",
    installMenu: "Zainstaluj aplikację",
    gotIt: "Jasne",
    close: "Zamknij",
    offlineTitle: "Brak internetu",
    offlineBody: "Sweet potrzebuje internetu, żeby odtwarzać filmy i kamerki. Sprawdź połączenie i spróbuj ponownie.",
    retry: "Spróbuj ponownie",
    recent: "Ostatnio otwierane",
  },
  notifications: {
    title: "Powiadomienia",
    empty: "Na razie nic nowego. Obserwuj gwiazdy i studia albo dodaj kamerki do ulubionych, a ich nowości pojawią się tutaj.",
    newVideos: "Nowe filmy",
    liveNow: "Teraz na żywo",
    markRead: "Oznacz wszystkie jako przeczytane",
    pushOn: "Włącz powiadomienia",
    pushOff: "Wyłącz powiadomienia",
    pushHint: "Dowiaduj się o nowych filmach i ulubionych transmisjach, nawet gdy Sweet jest zamknięty.",
    pushBlocked: "Powiadomienia od Sweet są zablokowane w ustawieniach przeglądarki.",
    pushUnsupported: "Ta przeglądarka nie obsługuje powiadomień. Na iPhonie najpierw dodaj Sweet do ekranu początkowego.",
    pushEnabled: "Powiadomienia są włączone",
    favorites: "Ulubione kamerki",
    addFavorite: "Dodaj do ulubionych",
    removeFavorite: "Usuń z ulubionych",
    favoritesEmpty: "Nie masz jeszcze ulubionych kamerek. Stuknij serduszko przy kamerce, żeby ją dodać.",
    offline: "Offline",
    viewAll: "Zobacz wszystko",
  },
  forYou: {
    title: "Dla Ciebie",
    all: "Wszystko",
    continueWatching: "Oglądaj dalej",
    intro: "Wybrane na podstawie tego, co lubisz, zapisujesz, oglądasz i obserwujesz.",
    empty: "Polub, zapisz albo zaobserwuj kilka filmów i gwiazd, a pojawią się tu filmy wybrane specjalnie dla Ciebie.",
    more: "Więcej",
  },
  shorts: {
    straight: "Hetero",
    gay: "Geje",
    trans: "Trans",
    watchFull: "Obejrzyj cały film",
    like: "Polub",
    liked: "Polubiono",
    save: "Zapisz",
    saved: "Zapisano",
    share: "Udostępnij",
    copied: "Link skopiowany",
    soundOn: "Włącz dźwięk",
    soundOff: "Wyłącz dźwięk",
    tapForSound: "Stuknij, żeby włączyć dźwięk",
    report: "Zgłoś",
    follow: "Obserwuj",
    following: "Obserwujesz",
    previous: "Poprzedni",
    next: "Następny",
    close: "Zamknij",
    end: "Na razie to wszystko. Więcej w zakładce Filmy.",
    empty: "Nie ma tu jeszcze shortsów.",
    live: "Na żywo",
    watchLive: "Oglądaj na żywo za darmo",
    watching: "{n} ogląda",
    profile: "Profil",
    moreLive: "Więcej kamerek na żywo",
  },
  search: {
    searches: "Wyszukiwania",
    popular: "Popularne wyszukiwania",
    categories: "Kategorie",
    searchFor: "Szukaj filmów: „{q}”",
    nothingFor: "Brak wyników dla „{q}”.",
    title: "Szukaj na Sweet",
    placeholder: "Szukaj filmów, osób i marek",
    hint: "Znajdź filmy, gwiazdy, studia i kategorie. Naciśnij / w dowolnym miejscu, żeby zacząć pisać.",
    stars: "Gwiazdy",
    productions: "Studia",
    other: "Inne",
    otherProfiles: "Inne profile",
    nothing: "Nic nie znaleziono",
    tryAgain: "Sprawdź pisownię albo wpisz coś ogólniejszego.",
    backHome: "Wróć na stronę główną",
  },
  notFound: { title: "Ta strona nie istnieje", body: "Film mógł zostać usunięty albo link jest błędny.", home: "Na stronę główną" },
  common: {
    close: "Zamknij",
    copy: "Kopiuj",
    copied: "Skopiowano",
    more: "Więcej",
    loading: "Ładowanie",
    clearAll: "Wyczyść wszystko",
    browseVideos: "Przeglądaj filmy",
    scrollLeft: "Przewiń w lewo",
    scrollRight: "Przewiń w prawo",
  },
  actions: {
    react: "Polub",
    reacted: "Polubiono",
    save: "Zapisz",
    saved: "Zapisano",
    follow: "Obserwuj",
    following: "Obserwujesz",
    followName: "Obserwuj {name}",
    unfollowName: "Przestań obserwować {name}",
    moreOptions: "Więcej opcji",
    share: "Udostępnij",
    copyLink: "Kopiuj link",
    linkCopied: "Link skopiowany",
    report: "Zgłoś",
    home: "Sweet — strona główna",
    onSweet: "{name} na Sweet",
    joinMe: "Dołącz do mnie na Sweet",
    inviteLink: "Twój link z zaproszeniem",
  },
  library: {
    savedEmpty: "Nic jeszcze nie zapisano",
    savedHint: "Stuknij zakładkę pod dowolnym filmem, żeby go tu zachować. Lista jest przechowywana tylko na tym urządzeniu.",
    reactedEmpty: "Brak polubionych filmów",
    reactedHint: "Filmy, którym dasz serduszko, pojawią się tutaj, od najnowszych.",
    watchingEmpty: "Nic jeszcze nie obejrzano",
    watchingHint: "Odtwarzane filmy pojawią się tutaj z dokładnym momentem, w którym je przerwano, i ruszą od tego miejsca, gdy otworzysz je ponownie.",
    removeWatching: "Usuń z oglądanych",
    removeVideo: "Usuń {title} z oglądanych",
    followingEmpty: "Nikogo jeszcze nie obserwujesz",
    followingHint: "Stuknij + przy twórcy lub studiu, a jego najnowsze filmy będą się tu zbierać. Obserwowani są zapisywani tylko na tym urządzeniu.",
    discoverModels: "Odkryj gwiazdy",
    noVideosHint: "Wybierz inną kategorię — nowe filmy dodajemy codziennie.",
    backToAll: "Wróć do wszystkich filmów",
  },
  player: {
    resumesAt: "Wznowienie od {at}",
    startOver: "Od początku",
    unavailable: "Ten film jest teraz niedostępny.",
    play: "Odtwórz",
    pause: "Pauza",
    seek: "Przewiń",
    back10: "10 sekund wstecz",
    forward10: "10 sekund do przodu",
    mute: "Wycisz",
    unmute: "Włącz dźwięk",
    volume: "Głośność",
    settings: "Ustawienia",
    pip: "Obraz w obrazie",
    fullscreen: "Pełny ekran",
    exitFullscreen: "Zamknij pełny ekran",
    quality: "Jakość",
    speed: "Prędkość odtwarzania",
    normal: "Normalna",
    auto: "Auto",
    partner: "partnera",
  },
  ads: { ad: "Reklama", advertisement: "Reklama", muteAd: "Wycisz reklamę", unmuteAd: "Włącz dźwięk reklamy", skipIn: "Pomiń za {n}", skipAd: "Pomiń reklamę ›" },
  auth: {
    username: "Nazwa użytkownika",
    usernameOrEmail: "Nazwa użytkownika lub e-mail",
    emailOptional: "E-mail (opcjonalnie)",
    password: "Hasło",
    currentPassword: "Obecne hasło",
    newPassword: "Nowe hasło",
    confirmPassword: "Powtórz hasło",
    confirmNewPassword: "Powtórz nowe hasło",
    showPassword: "Pokaż hasło",
    hidePassword: "Ukryj hasło",
    forgot: "Nie pamiętasz hasła?",
    remember: "Nie wylogowuj mnie",
    logIn: "Zaloguj się",
    createAccount: "Załóż konto",
    usernameHelp: "3–24 znaki: litery, cyfry, kropki lub podkreślenia. Widoczna w Rankingach.",
    emailHelp: "Służy tylko do resetowania hasła. Możesz go dodać później w ustawieniach konta.",
    passwordHelp: "Co najmniej 8 znaków.",
    adult: "Mam ukończone 18 lat.",
    agree: "Akceptuję {terms} i {privacy}.",
    terms: "Regulamin",
    privacy: "Politykę prywatności",
    savePhrasesTitle: "Zapisz swoje frazy odzyskiwania",
    savePhrasesBody: "Konto zostało założone bez adresu e-mail, więc te frazy pozwolą Ci do niego wrócić, jeśli zapomnisz hasła.",
    continue: "Dalej",
    resetHow: "Jak zresetować hasło",
    byEmail: "Wyślij mi link e-mailem",
    byPhrase: "Użyj frazy odzyskiwania",
    phraseIntro: "Dla kont założonych bez e-maila: wpisz nazwę użytkownika i dowolną z fraz odzyskiwania zapisanych przy rejestracji.",
    phrase: "Fraza odzyskiwania",
    phrasePlaceholder: "słowo słowo słowo słowo",
    phraseHelp: "4 słowa jednej frazy. Każda fraza działa tylko raz.",
    saveNewPassword: "Zapisz nowe hasło",
    sendLink: "Wyślij link do resetu",
  },
  phrases: {
    warning: "Zapisz je teraz: nie zobaczysz ich ponownie. Jeśli zapomnisz hasła, nazwa użytkownika i dowolna z tych fraz pozwolą ustawić nowe. Każda fraza działa tylko raz. Nie pokazuj ich nikomu.",
    list: "Twoje frazy odzyskiwania",
    copyAll: "Kopiuj wszystkie",
    download: "Pobierz .txt",
    savedCheck: "Moje frazy odzyskiwania są zapisane w bezpiecznym miejscu.",
    done: "Gotowe",
    fileTitle: "Frazy odzyskiwania Sweet dla @{username}",
    fileHow: "Jeśli zapomnisz hasła, wejdź na {url}, wybierz „{option}” i wpisz nazwę użytkownika oraz dowolną z tych fraz.",
    filePrivate: "Każda fraza działa tylko raz. Nie pokazuj ich nikomu: każdy, kto zna Twoją nazwę użytkownika i jedną z tych fraz, może przejąć Twoje konto.",
    none: "Twoje konto nie ma e-maila ani fraz odzyskiwania. Jeśli zapomnisz hasła, nie odzyskasz do niego dostępu. Utwórz frazy odzyskiwania teraz.",
    optional: "Frazy odzyskiwania pozwalają ustawić nowe hasło bez e-maila. Są opcjonalne, dopóki konto ma adres e-mail.",
    left: "Niewykorzystane frazy: {left} z {total}.",
    leftMade: "Niewykorzystane frazy: {left} z {total}, utworzone {date}.",
    how: "Każda z nich razem z nazwą użytkownika pozwala raz ustawić nowe hasło. Zgubione? Utwórz nowe, a stare przestaną działać.",
    make: "Utwórz frazy odzyskiwania",
    makeNew: "Utwórz nowe frazy",
  },
  account: {
    menu: "Menu konta",
    settings: "Ustawienia konta",
    profiles: "Twoje profile",
    logOut: "Wyloguj się",
    uploadPhoto: "Prześlij zdjęcie",
    removePhoto: "Usuń obecne zdjęcie",
    displayName: "Wyświetlana nazwa",
    showInRankings: "Pokazuj mnie w Rankingach",
    rankingsHelp: "Twoja nazwa, zdjęcie i statystyki oglądania są widoczne na publicznej stronie {link}. Wyłącz to, żeby się tam nie pokazywać; Twój czas i tak będzie liczony.",
    save: "Zapisz",
    emailHelp: "Służy tylko do wysłania linku, jeśli zapomnisz hasła. Zostaw puste, żeby go usunąć.",
    saveEmail: "Zapisz e-mail",
    changePassword: "Zmień hasło",
    deleteWarning: "To trwale usunie Twoje konto, zapisane filmy, polubienia i obserwowanych. Tego nie da się cofnąć.",
    typeToConfirm: "Wpisz {word}, aby potwierdzić",
    deleteMine: "Usuń moje konto",
  },
  pay: {
    billingPeriod: "Okres rozliczeniowy",
    monthly: "Miesięcznie",
    yearly: "Rocznie",
    yourPlan: "Twój plan",
    month: "miesiąc",
    year: "rok",
    oneMonth: "1 miesiąc",
    months: "{n} mies.",
    oneYear: "1 rok",
    years: "{n} lata",
    perMonth: "{price} miesięcznie",
    save: "Taniej o {n}%",
    comingSoon: "Już wkrótce",
    reward: "−{n}% — Twoja nagroda",
    plays: "Gry w Sweet Room: {n}",
    addedAtOnce: "Dodawane od razu",
    get: "Wybierz {plan}",
    addMonth: "Dodaj miesiąc",
    addYear: "Dodaj rok",
    opensSoon: "Płatności ruszą wkrótce",
    alreadyMember: "Masz już konto?",
    choose: "Wybierz sposób płatności",
    payWith: "Zapłać przez",
    starsInBot: "{n} Stars w naszym bocie na Telegramie",
    card: "Karta",
    crypto: "Krypto",
    cryptoMore: "BTC, USDT, ETH, TON i ponad 30 innych",
    tooManyStars: "To za dużo na jedną płatność w Telegram Stars.",
    cardMin: "Płatności kartą od {price}.",
    payStars: "Zapłać przez Telegram Stars",
    preparing: "Przygotowujemy płatność…",
    loginFirst: "Najpierw się zaloguj",
    cantStart: "Nie udało się rozpocząć płatności",
    noAdsCoins: "Bez reklam + {n} Sweet Coins",
    addedOnPay: "Trafiają na saldo zaraz po płatności",
    payInTelegram: "Zapłać w Telegramie",
    waitingStars: "Czekamy na płatność — ta strona odświeży się sama",
    allSet: "Gotowe!",
    noAds: "Bez reklam.",
    noAdsUntil: "Bez reklam do {date}.",
    coinsAdded: "Dopisaliśmy {n} monet do Twojego salda.",
    startWatching: "Zacznij oglądać",
    great: "Super",
    payCard: "Zapłać kartą",
    failedTitle: "Płatność nie przeszła",
    failedBody: "Nic nie zostało pobrane. Możesz spróbować ponownie.",
    newTab: "Zapłać w nowej karcie",
    newTabBody: "Karta, Apple Pay lub Google Pay na bezpiecznej stronie Chain2Pay. Ta strona odświeży się sama po opłaceniu.",
    waiting: "Czekamy na płatność…",
    openAgain: "Otwórz stronę płatności ponownie",
    somethingWrong: "Coś poszło nie tak. Spróbuj ponownie za minutę.",
    offline: "Wygląda na to, że nie masz internetu. Spróbuj ponownie za minutę.",
    bestValue: "Najlepsza oferta",
    coins: "monet",
    orStars: "lub {n} Stars",
    packsSoon: "Pakiety monet już wkrótce w sprzedaży.",
    nCoins: "{n} Sweet Coins",
    collected: "+{n} Sweet Coins odebrane!",
    collectedToday: "Odebrane dzisiaj",
    nextBonus: "Następny bonus za",
    collecting: "Odbieranie…",
    collect: "Odbierz {n} Sweet Coins",
    alreadyCollected: "Dzisiejsze monety są już odebrane. Wróć jutro.",
    offerLabel: "Sweet Coins i Premium",
    offerTitle: "Zdobądź Sweet Coins",
    offerFor: "Do Sweet Room i płatnych filmów",
    premiumFrom: "Premium od {price}",
    upTo: "Bez reklam + do {n} monet",
    packsFrom: "Pakiety monet od {price}",
    collectFree: "Albo odbieraj darmowe monety codziennie",
    offerButton: "Oferta Sweet Coins",
    guestCollected: "+{n} Sweet Coins! Jeśli nie chcesz stracić monet, zarejestruj się na Sweet.",
    guestKeep: "Bez konta monety są przechowywane przez {days} dni, a potem przepadają.",
    guestSignup: "Zarejestruj się za darmo i zachowaj je",
    guestLogin: "Masz już konto? Zaloguj się",
    guestExpire: "{n} monet przepadnie {date}.",
    guestUnsaved: "Twoje monety nie są jeszcze zapisane: zarejestruj się, aby je zachować",
    guestExpiring: "{n} z twoich Sweet Coins przepadnie w ciągu doby. Zarejestruj się za darmo, aby je zachować.",
  },
  footer: {
    copyright: "Prawa autorskie",
    takedown: "Usuwanie treści",
    contact: "Kontakt",
    creators: "Dla twórców",
    claim: "Przejmij profil",
    webmasters: "Dla webmasterów",
    terms: "Regulamin",
    privacy: "Prywatność",
    info: "Informacje o witrynie",
    telegram: "{site} na Telegramie",
  },
  report: {
    heading: "Zgłoś film",
    reason: "Powód",
    takedown: "Prawa autorskie / DMCA",
    abuse: "Występuję w tym filmie bez mojej zgody",
    minor: "Ktoś w tym filmie może mieć mniej niż 18 lat",
    other: "Coś innego",
    url: "Link do filmu lub ID",
    email: "Twój e-mail",
    details: "Szczegóły",
    detailsPlaceholder: "Co mamy usunąć i dlaczego?",
    send: "Wyślij zgłoszenie",
  },
};
